import { useLazyQuery } from "@apollo/client";

import { getAddress, getSuggestedAddresses } from "core/includes/queries";
import { useAppState } from "core/contexts/AppContext";
import { DEFAULT_COUNTRY_CODE_CONFIG } from "core/includes/constants";

const useSuggestedAddresses = () => {
    const [appState] = useAppState();

    const [getSuggestedAddressesQuery] = useLazyQuery(getSuggestedAddresses, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    });

    const [getAddressDetail] = useLazyQuery(getAddress, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    });

    const getSuggestedDetailedAddresses = async (
        {
            address,
            postCode
        }:
        {
            address: string,
            postCode: number,
        }
    ) => {
        if (address) {
            const detailedAddress = await getSuggestedAddressesQuery({
                variables: {
                    q: address + ' ' + postCode,
                    orderCountryCode: appState.cart.countryCode,
                },
            }).then(({ data }) => {
                if (data && !!data.suggestedAddresses?.length) {
                    return getAddressDetail({
                        variables: {
                            addressId: data.suggestedAddresses[0].address_id,
                            orderCountryCode: appState.cart?.countryCode || DEFAULT_COUNTRY_CODE_CONFIG.code
                        }
                    }).then(({ data }) => {
                        return data;
                    });
                }
            });

            return detailedAddress;
        }

        return null;
    };

    return {
        getSuggestedDetailedAddresses,
    };
};

export default useSuggestedAddresses;